const responseHome = {
  "payload": {
    "adminFirstName": "Ibliss",
    "adminLastName": "Coré",
    "companyLogo": "https://ibliss-icons-dev.s3.amazonaws.com/clients/1-cajapadre.png",
    "companyName": "LUCASIAN LABS S.A.S. ambiente desarrollo",
    "role": {
      "roleId": 1,
      "roleName": "SUPER ADMINISTRADOR"
    }
  }
};
  
  export const service = {
    getHome: () => new Promise(resolve => {
      setTimeout(resolve({ data: responseHome }), 1000);
    }),
  
  }